import { getFlag } from '../common-props';

/**
 * This method returns whether the code is currently running on a runtime site
 * or not
 */
export function isRuntimeSite() {
  let result = true;
  if (globalThis.parentFlags) {
    result = false;
  } else if (globalThis.commonProps && !globalThis.rtCommonProps) {
    result = false;
  }
  return result;
}
export function shouldShowMarketingContent() {
  return getFlag('marketing.popups.enabled');
}
//# sourceMappingURL=index.js.map